import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface UsuarioPublico {
  id: string;
  email: string;
  nome: string;
  role: 'admin' | 'atendente' | 'supervisor';
  ativo: boolean;
}

interface AuthState {
  token: string | null;
  usuario: UsuarioPublico | null;
  // Actions
  login: (token: string, usuario: UsuarioPublico) => void;
  logout: () => void;
  isAuthenticated: () => boolean;
}

/**
 * Store global de autenticação.
 * - Token e usuario persistem em localStorage automaticamente (zustand/persist)
 * - login(): salva
 * - logout(): limpa tudo
 * - isAuthenticated(): true se há token
 */
export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      usuario: null,

      login: (token, usuario) => set({ token, usuario }),

      logout: () => {
        set({ token: null, usuario: null });
      },

      isAuthenticated: () => get().token !== null,
    }),
    {
      name: 'nexo-suporte-auth',
      storage: createJSONStorage(() => localStorage),
      // Persiste apenas token + usuario (não as funções)
      partialize: (state) => ({ token: state.token, usuario: state.usuario }),
    }
  )
);
